module.exports = __webpack_public_path__ + "media/Puck-by-Qrespi-Introduction-v22.8b48cdce.mp4";